module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Cursor-b5c0712326dd2d48d124df0093e6ee47.svg";